import Vue from 'vue';
import { VueConstructor } from 'vue/types/umd';
import { PriceSettings } from '@/types/price-settings'

export default Vue.component('simple-renderer', {
    render: function (createElement) {
        return createElement(this.component, { props: { data: this.data, typeCode: this.typeCode }, on: this.$listeners });
    },
    props: {
        component: {} as () => VueConstructor<Vue>,
        data: {} as () => PriceSettings,
        typeCode: String
    }
})